import React from 'react';

import {
  Wrapper,
} from './style';

const LystLogo = ({scale}) => (
  <Wrapper scale={scale}>
    <svg id='Layer_1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 216.3 121.6'>
        <polygon className='st0' points='42.2,121.6 59.4,84.6 31.6,28.8 49.9,28.8 68.1,66 84.8,28.8 102.4,28.8 59.6,121.6'
        />
        <path className='st0' d='M113.1,71.9c4.2,3.8,10.8,6.1,17,6.1c4.5,0,7.9-2.2,7.9-5.2c0-9.3-30.1-6-30.1-26c0-11.9,11.5-19.3,23.8-19.3 c8.1,0,16.9,3.1,21,6.3l-7.8,12c-3.2-2.3-7.4-4.2-11.9-4.2c-4.6,0-8.4,1.8-8.4,5c0,8.1,30.1,4.9,30.1,26.4 c0,11.9-11.6,19.2-24.7,19.2c-8.6,0-17.7-2.9-25-8.3L113.1,71.9z'
        />
        <path className='st0' d='M215.6,90.8c-2.2,0.8-7.2,1.3-10.4,1.3c-10,0-17.3-3.3-21.5-9c-3.2-4.2-4.6-9.7-4.6-18.6V42.8h-17.3V28.8h17.3 V11.5h16.6v17.3h20.5v14.1h-20.5v23.7c0,3.8,0.6,6.1,2,7.8c1.7,1.9,4.4,3.1,8.4,3.1c2.4,0,5.6-0.4,6.8-0.6L215.6,90.8z'
        />
        <path className='st0' d='M0,28.8V0h16.6v28.8v14.1v23.7c0,3.8,0.6,6.1,2,7.8c1.7,1.9,4.4,3.1,8.4,3.1c2.4,0,5.6-0.4,6.8-0.6l2.6,14.1 c-2.2,0.8-7.2,1.3-10.4,1.3c-10,0-17.3-3.3-21.5-9C1.4,78.9,0,73.4,0,64.6V42.8V28.8z'
        />
    </svg>
  </Wrapper>
);

export default LystLogo;



// WEBPACK FOOTER //
// ./src/components/LystLogo/index.js